import { createRouter, createWebHistory } from 'vue-router';
import Layout from '@/layout';
import { reduce } from 'core-js/core/array';



// 公共路由
export const constantRoutes = [
  {
      path: '/redirect',
      component: Layout,
      hidden: true,
      children: [
        {
          path: '/redirect/:path(.*)',
          component: () => import('@/views/redirect')
        }
      ]
  },
  {
      path: '/login',
      component: () => import('@/views/login'),
      hidden: true
  },
  {
      path: '/user',
      component: Layout,
      hidden: true,
      redirect: 'noredirect',
      children: [
          {
              path: 'profile',
              component: () => import('@/views/system/user/profile/index'),
              name: 'Profile',
              meta: { title: '个人中心', icon: 'user' }
          }
      ]
  },
]

export const dynamicRoutes = [
  {
    path: '/system/dict-data',
    component: Layout,
    hidden: true,
    permissions: ['system:dict:list'],
    children: [
      {
        path: 'index/:dictId',
        component: () => import('@/views/system/dict/data'),
        name: 'DictData',
        meta: { title: '字典数据', activeMenu: '/system/dict' }
      }
    ]
  },
  {
    path: '/system/user-auth',
    component: Layout,
    hidden: true,
    permissions: ['system:user:edit'],
    children: [
      {
        path: 'role/:userId',
        component: () => import('@/views/system/user/authRole'),
        name: 'AuthRole',
        meta: { title: '分配角色', activeMenu: '/system/user' }
      }
    ]
  },
  {
      path: '/system/role-auth',
      component: Layout,
      hidden: true,
      permissions: ['system:role:edit'],
      children: [
        {
          path: 'user/:roleId',
          component: () => import('@/views/system/role/authUser'),
          name: 'AuthUser',
          meta: { title: '分配用户', activeMenu: '/system/role' }
        }
      ]
  },
  {
    path: '/system/scheduling-data',
    component: Layout,
    hidden: true,
    permissions: ['system:scheduling:list'],
    children: [
      {
        path: 'index',
        component: () => import('@/views/system/scheduling/data'),
        name: 'Data',
        meta: { title: '生成排班', activeMenu: '/system/scheduling' }
      }
    ]
  },
  {
    path: '/caseHistory/dataSource',
    component: Layout,
    hidden: true,
    permissions: ['caseHistory:list'],
    children: [
      {
        path: 'index/:docId',
        component: () => import('@/views/caseHistory/dataSource/index'),
        name: 'DataSource',
        meta: { title: '节点数据', activeMenu: '/caseHistory/index' }
      }
    ]
  },
  {
    path: '/caseHistory/layout',
    component: Layout,
    hidden: true,
    permissions: ['caseHistory:list'],
    children: [
      {
        path: 'index/:docId',
        component: () => import('@/views/caseHistory/layout/index'),
        name: 'Layout',
        meta: { title: '病历格式', activeMenu: '/caseHistory/index' }
      }
    ]
  },
];

// 创建路由实例
const router = createRouter({
    history: createWebHistory(),
    routes: constantRoutes
})

// 防止连续点击多次路由报错
let routerPush = router.push;
router.push = function push(location) {
    return routerPush.call(this, location).catch(err => err)
}

export default router